<template>
  <div class="add-card-drawer">
    <!-- <el-drawer
      
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="auto"
    >
      
    </el-drawer> -->
    <div class="drawer-overlay" v-show="drawer" @click="handleClose"></div>
    <div class="drawer-block" :class="{ active: drawer }">
      <div class="close-btn el-dialog__close el-icon el-icon-close" @click="handleClose"></div>
      <div class="drawer-container" v-loading="drawerLoading">
        <div class="info">
          <div class="img-block">
            <img :src="chooseProductDetail.photo">
          </div>
          <div class="product-detail show-on-pad">
            <p class="no">{{ chooseProductDetail.no }}</p>
            <p class="ind_name">{{ chooseProductDetail.ind_name }}</p>
            <p class="name">{{ chooseProductDetail.name }}</p>
          </div>
        </div>
        <div class="product-sku">
          <div class="product-detail hide-on-pad">
            <p class="ind_name">{{ chooseProductDetail.no }} {{ chooseProductDetail.ind_name }}</p>
            <p class="name">{{ chooseProductDetail.name }}</p>
          </div>
          <div class="sku-box">
            <div class="cloud-prop">
              <div class="metatit">{{ $t('add_card_drawer.color') }}</div>
              <div class="item-bar">
                <div
                  class="item pos-center"
                  v-for="(item,index) in chooseProductDetail.product_standard.color"
                  :key="index"
                  :class="{'active':select.colorIndex == index}"
                >
                  <img
                    @click="selectSku(index,'color')"
                    class="img-responsive"
                    :src="item.photo"
                    alt
                  />
                </div>
              </div>
            </div>
            <div class="cloud-prop">
              <div class="metatit">{{ $t('add_card_drawer.standard') }}</div>
              <div class="item-bar">
                <div
                  class="item pos-center"
                  v-for="(item,index) in chooseProductDetail.product_standard.standard"
                  :key="index"
                  :class="{'active':select.bustIndex == index}"
                  @click="selectSku(index,'bust')"
                >{{item.name}}</div>
              </div>
            </div>
            <div class="cloud-prop">
              <div class="metatit">{{ $t('add_card_drawer.size') }}</div>
              <div class="item-bar">
                <div
                  class="item pos-center"
                  v-for="(item,index) in chooseProductDetail.product_standard.size"
                  :key="index"
                  :class="{'active':select.sizeIndex == index}"
                  @click="selectSku(index,'size')"
                >{{item.name}}</div>
              </div>
            </div>
            <div class="cloud-prop">
              <div class="metatit">{{ $t('add_card_drawer.qty') }}</div>
              <div class="item-bar">
                <button class="item pos-center" @click="handleDecrement">－</button>
                <div class="item pos-center clear-border">{{number}}</div>
                <button class="item pos-center" @click="handleIncrement">+</button>
              </div>
            </div>
          </div>
          <div class="btns">
            <div class="btn btn-orange" @click="handleAddCart">{{ $t('add_card_drawer.add_cart') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getGoodsDetail, addCart } from '../../api';

  export default {
    name: 'add-card-drawer',
    data() {
      return {
        drawer: false,
        choosePid: '',
        chooseProductDetail: {
          product_standard: {
            standard: [],
            color: [],
            size: []
          }
        },
        direction: 'btt',
        drawerLoading: false,
        select: {
          colorIndex: 0,
          bustIndex: 0,
          sizeIndex: 0,
        },
        sku: {
          color: ["黑色", "白色", "蓝白色", "棕色"],
          bust: ["32", "34", "36", "38"],
          size: ["A", "B", "C", "D"],
        },
        number: 1,
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    methods: {
      async handleAddCart(e) {
        e.preventDefault();
        this.drawerLoading = true;
        try {
          const price = this.chooseProductDetail.price2 ? this.chooseProductDetail.price2 : this.chooseProductDetail.price1 ? this.chooseProductDetail.price1 : this.chooseProductDetail.price;
          const postData = {
            store_id: this.userInfo.user.store_id,
            product_id: this.chooseProductDetail.id,
            color: this.chooseProductDetail.product_standard.color[this.select.colorIndex].name,
            size: this.chooseProductDetail.product_standard.size[this.select.sizeIndex].name,
            standard: this.chooseProductDetail.product_standard.standard[this.select.bustIndex].name,
            qty: this.number,
            price
          };
          // console.log('postData',postData);
          // return;
          await addCart(postData);

          this.drawerLoading = false;

          this.$message({
            message: this.$t('alert_message.add_cart_success'),
            type: "success",
          });
          this.$store.commit('SET_CART_NUMBER');
          this.handleClose();
        } catch (error) {
          console.log(error);
          this.$message({
            message: this.$t('alert_message.some_error'),
            type: "error",
          });
          this.drawerLoading = false;
          this.handleClose();
        }
      },
      async handleOpenAddCartDrawer(pid) {
        // 如果沒登入跳到登入頁
        if(!this.userInfo) {
          this.$router.push({ name:'register', query: { type: 'login' }});
          return;
        }
        document.querySelector('body').style.overflow="hidden";
        this.drawerLoading = true;
        this.drawer = true;
        this.choosePid = pid;
        // 取得商品資料
        try {
          const { product } = await getGoodsDetail({ goods_id: pid });  
          this.chooseProductDetail = product;
          this.drawerLoading = false;
        } catch (error) {
          this.handleClose()
        }
      },
      handleClose() {
        document.querySelector('body').style.overflow="";
        this.drawer = false;
        this.choosePid = '';
        this.chooseProductDetail = {
          product_standard: {
            standard: [],
            color: [],
            size: []
          }
        };
      },
      selectSku(index, type) {
        switch (type) {
          case "color":
            this.select.colorIndex = index;
            break;
          case "bust":
            this.select.bustIndex = index;
            break;
          case "size":
            this.select.sizeIndex = index;
            break;
        }
      },
      handleDecrement() {
        if (this.number == 1) return;
        this.number--;
      },
      handleIncrement() {
        if (this.number == this.chooseProductDetail.max_order_qty) return;
        this.number++;
      },
    }
  }
</script>

<style lang="less" scoped>
.add-card-drawer {
  .drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    z-index: 2000;
  }
  .drawer-block {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 2001;
    background: white;
    border-radius: 10px;
    transform: translateY(100%);
    transition: .6s;
    &.active {
      transform: translateY(0%);
    }
  }
  .close-btn {
    font-size: 1.5rem;
    color: #888;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .drawer-container {
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    @media (max-width: 992px) {
      flex-direction: column;
      // height: 500px;
      // overflow: scroll;
      justify-content: initial;
      align-items: initial;
    }
    .info {
      margin-right: 60px;
      height: 100%;
      @media (max-width: 992px) {
        display: flex;
        margin-bottom: 30px;
        width: 100%;
      }
      .img-block {
        img {
          display: block;
          width: 100%;
          border-radius: 5px;
        }
        @media (max-width: 992px) {
          flex: 0 0 80px;
          margin-right: 20px;
        }
      }
    }
    .product-sku {
      @media (max-width: 992px) {
        flex: 1;
        overflow: scroll;
      }
    }
    .product-detail {
      .no {
        margin-bottom: 10px;
      }
      .ind_name {
        margin-bottom: 10px;
      }
      .name {
        font-size: 1.5rem;
        font-weight: 400;
        margin-bottom: 10px;
      }
    }
    .cloud-prop {
      margin-bottom: 18px;
      .metatit {
        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
      }
      .item-bar {
        display: flex;
        margin-top: 5px;
        .item {
          cursor: pointer;
          margin-right: 20px;
          width: 35px;
          height: 35px;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          background: var(--unnamed-color-ffffff);
          border: 1px solid var(---unnamed-color-707070);
          color: var(---unnamed-color-707070);
        }
        .item.active {
          padding: 2px;
          border: 1px solid var(---unnamed-color-ec4f00);
          color: var(---unnamed-color-ec4f00);
        }
        .clear-border {
          border: none;
        }
      }
    }
    .btns {
      margin-top: 40px;
    }
  }
}
</style>